<template>
    <div class="ui-page">
        <ui-page-header title="Postagens" subtitle="Postagens publicadas no blog do portal.">
            <v-btn v-if="$allowed('create')" id="btnNew" color="primary" depressed to="/blog/posts/novo">
                <v-icon left small>mdi-plus</v-icon>
                Incluir
            </v-btn>
        </ui-page-header>

        <ui-table-card clearable :can-clear="hasFilters" @clear="clearFilters">
            <template #toolbar>
                <v-text-field id="name" v-model="dataList.filter.title" placeholder="Buscar pelo título" prepend-inner-icon="mdi-magnify"
                    dense outlined hide-details class="ui-toolbar__search" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-select dense :items="dataset.categories" placeholder="Todas as categorias"
                    v-model="dataList.filter.category" item-value="id" item-text="name" outlined
                    hide-details class="ui-toolbar__field" :menu-props="{ offsetY: true }" @change="applyFilters">
                </v-select>
            </template>

            <v-data-table :headers="dataList.headers" :items="dataList.data" :server-items-length="dataList.count"
                :options.sync="dataList.options" :loading="dataList.loading" disable-sort hide-default-footer
                no-data-text="Nenhuma postagem foi encontrada" loading-text="Carregando dados..." class="ui-clickable-rows"
                @click:row="openRow">
                <template v-slot:[`item.title`]="{ item }">
                    <span class="ui-cell-main">{{ item.title }}</span>
                </template>

                <template v-slot:[`item.created_at`]="{ item }">
                    {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm") }}
                </template>

                <template v-slot:[`item.category`]="{ item }">
                    {{ item.category && item.category.name ? item.category.name : 'N/A' }}
                </template>

                <template v-slot:[`item.author`]="{ item }">
                    {{ item.author && item.author.name ? item.author.name : 'N/A' }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <ui-row-actions :actions="[
                        { text: 'Editar', icon: 'mdi-pencil-outline', disabled: !$check('Blog', 'PATCH'), handler: () => viewItem(item) },
                        { text: 'Excluir', icon: 'mdi-delete-outline', danger: true, disabled: !$check('Blog', 'DELETE'), handler: () => deleteItem(item) },
                    ]" />
                </template>
            </v-data-table>

            <template #footer>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.itemsPerPage"
                    :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </template>
        </ui-table-card>
    </div>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "PostList",

    data: () => ({
        dataset: {
            categories: [],
            data: {}
        },
        dataList: {
            filter: {
                title: "",
                category: "",
            },
            headers: [
                { text: "Título", value: "title" },
                { text: "Autor", value: "author" },
                { text: 'Categoria', value: "category" },
                { text: "Criado em", value: "created_at" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    computed: {
        hasFilters() {
            return Object.values(this.dataList.filter).some((value) => value);
        },
    },

    created() {
        this.load();
    },

    methods: {

        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        filterDebounced: _.debounce(function () {
            this.applyFilters();
        }, 400),

        clearFilters() {
            this.dataList.filter = { title: "", category: "" };
            this.applyFilters();
        },

        // A troca de tamanho e seguida de update:page(1), que recarrega.
        setPageSize(size) {
            this.dataList.options.itemsPerPage = size;
        },

        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {


            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;
            
            try {
                const result = await axios.get('/api/posts', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        // A linha abre o detalhe so com a mesma permissao do "Editar".
        openRow(item) {
            if (this.$check('Blog', 'GET')) this.viewItem(item);
        },

        viewItem(item) {
            this.$router.push(`posts/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir Postagem',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/posts/${item.id}`)

                this.$dialog.notify.info("Postagem excluída com sucesso", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },
    },
};
</script>
